module.exports = {
    hygl: {
        formTitle: '会议管理',
        common: {
            to: '至',
            cancel: '取 消',
            confirm: '确 认',
            confirm2: '确 定',
            close: '关 闭',
            save: '保 存',
            tip: '提示',
            no: '否',
            yes: '是',
            operateTip: '操作提示',
            view: '预 览',
            print: '打 印',
            commit: '提 交',
            look: '查 看',
            del: '删 除',
            confirmTip: '确认操作',
            add: '新 增',
            edit: '编 辑',
            export: '导出',
            noData: '暂无数据',
            update: '修 改',
            down: '下 载',
            statistics: '统计',
            topUp: '置顶',
            grounding: '上架',
            offShelf: '下架'
        },
        tableColumn: {
            index: '序号',
            fileName: '文件名称',
            meetingAgenda: '议题',
            file: '附件',
            status: '状态',
            noAttend: '未上会',
            doneAttend: '已上会',
            todoAttend: '待上会',
            cancelAttend: '已取消'
        },
        message: {
            fixTitle: '请填写文件标题！',
            selectPredeterminedType: '请选择预定类型',
            selectMeetShape: '请选择会议形式',
            selectPerson: '请先选择人员或部门！',
            meetingLater: '会议室开始时间不得晚于当前时间',
            meetingBegin: '结束时间不能早于开始时间',
            meetingBeginTo: '会议室开放时间为',
            noFindH5: '未检测到h5参数！请联系管理员',
            needBeginTime: '开始日期是必须的！',
            needEndTime: '结束日期是必须的！',
            selectData: '请先选择数据！',
            needUndertaker: '承办人是必须的',
            selectPerson2: '请选择人员！',
            departNull: '部门不能为空！',
            phoneNull: '电话不能为空！',
            phoneInvalid: '人员电话无效，请输入11位手机号!',
            reasonNeed: '不参会原因是必须的',
            transferNeed: '转派人员是必须的',
            transferReasonNeed: '转派原因是必须的',
            hasPerson: '该人员已存在',
            saveSuccess: '保存成功!',
            saveError: '保存失败',
            meetingCancel: '会议取消成功',
            meetingCancelFail: '会议取消失败',
            delSuccess: '删除成功！',
            isSelectYt: '已选择该议题！',
            delFile: '此操作将永久删除该文件, 是否继续？',
            selectMeetingMenu: '请选择会议议程！',
            noMeetingTitle: '暂无会议议题。',
            lationAfterCur: '预约时间不能小于当天！',
            lationAfterCurTime: '请在当前时间之后预约！',
            confirmCancelLation: '确定取消预约吗？',
            meetingOpenIn: '会议室开放周期为‘{day}’',
            meetingOpenIn2: '会议室开放周期为‘{day}’！请在开放周期内预定',
            meetingOpenIn3: '会议室开放时间为{day}',
            meetingNumExceed: '不能超过会议室可容纳人数',
            dellCancelNoticeTitle: '从{year}年{month}月{day}日开始，原定于每 {week} {hour}:{min} 到 {endhour}:${endMin} 的会议取消',
            dellCancelNoticeTitle2: '{name}预订的{time1}到{time2}时段的{meetName}已被{name2}取消',
            selectFloor: '请选择筛选楼层',
            meetingThemeNeed: '会议主题是必须的！',
            meetingTimeNeed: '会议时段是必须的！',
            sSmallCur: '开始时间不能小于当前时间',
            topTip: '最近置顶的，将显示在最前面',
            confirmTop: '确定置顶？',
            pleaseInputReason: '请输入拒绝原因',
            nohaveZw: '没有可打开的正文！',
            onlyOneData: '仅可选择一条数据!',
            confirmYtwsh: '您确认要将此议题设为未上会吗?',
            confirmYtysh: '您确认要将此议题设为已上会吗?',
            openMeeting: '您确认要将此会议设为已召开吗？',
            confirmCancel: '您确认取消吗?',
            noDataToExport: '没有可导出的数据！'
        },
        pageBtns: {
            selectMeeting: '选择议题',
            confirmStart: '确认开始',
            saveApplay: '去申请',
            finishLation: '完成预定',
            hyhz: '会议回执',
            bch: '不参会',
            hyjy: '会议纪要',
            ytjy: '议题纪要',
            ysh: '已上会',
            wsh: '未上会',
            bufa: '补发',
            sjqk: '收集情况',
            xf: '下 发',
            cklc: '查看流程',
            bftz: '补发通知',
            yzk: '已召开',
            hzxx: '回执信息',
            ewm: '二维码',
            bg: '变更',
            qx: '取消',
            jytp: '决议投票',
            szck: '设置查看',
            cxzk: '重新召开',
            ckyt: '查看议题',
            ckyc: '查看议程'
        },
        components: {
            fields: {
                flSubject: '会议主题',
                predeterminedType: '预定类型',
                meetingDate: '会议日期',
                dateRange: '应用日期范围',
                monthRange: '应用日期范围',
                meetingTime2: '会议时间：',
                meetingTimePoint: '会议时间点',
                meetingName: '会议室名称',
                meetingTypeName: '会议类型',
                meetShape: '会议形式',
                personName: '个人参会',
                attendName: '部门参会',
                workMum: '参会人数',
                meetHost: '会议主持人',
                attendLeader: '出席领导',
                flContent: '会议内容',
                bfTime: '选择补发范围',
                startTime: '会议开始时间',
                endTime: '会议结束时间',
                summaryName: '会议纪要人员',
                summaryPhone: '联系电话',
                openSgin: '是否开放签到',
                receiptEndTime: '回执时限',
                openExternalPerson: '是否有外联人员',
                openYt: '是否添加议题',
                externalPersonName: '联络人',
                sendInfo: '是否立即发送通知',
                flCreator: '召集人',
                flCreateDept: '召集部门',
                meetingAttach: '会议附件',
                isAttend: '是否参会',
                substitutePersonnel: '替会人员',
                notAttendingReason: '不参会原因',
                undertaker: '承办人'
            },
            addMeetingPerson: '添加参会人员',
            meetingPlan: '转会议计划',
            meetingRoom: '会议室',
            pleaseSelect: '请选择',
            conferenceThEmeemptyMessage: '请输入会议主题',
            bookingType: '预定类型',
            ookingTypeOption1: '一次性',
            ookingTypeOption2: '周例会',
            ookingTypeOption3: '月例会',
            bookingTypeEmptyMessage: '请选择会议形式',
            bookingTypeElementFormatter: '一次性：一次性\n2：部门参会',
            selectDate: '选择日期',
            startDate: '开始日期',
            endDate: '结束日期',
            startTime: '开始时间',
            endTime: '结束时间',
            selectTimeRange: '选择时间范围',
            selectMonth: '选择月',
            meetingTime: '会议时间',
            meetingTime3: '会议时间：{time}',
            meetingNameEmptyMessage: '请输入会议类型名称',
            meetingTypeOption: '新员工入职培训会',
            meetingTypeOption1: '部门讨论会',
            meetingTypeOption2: '部门季度会',
            meetingTypeOption3: '年度总结会',
            meetingTypeOption4: '员工动员大会',
            meetingTypeOption5: '部门会议',
            meetingTypeOption6: '项目会议',
            meetingTypeElementFormatter: '新员工入职培训会：新员工入职培训会\n部门讨论会：部门讨论会',
            meetFormEmptyMessage: '请选择会议形式',
            meetFormElementFormatter: '1：个人参会\n2：部门参会',
            personJoin: '个人参会',
            personJoinEmptyMessage: '请输入参会人员姓名',
            departJoin: '部门参会',
            meetingHostEmptyMessage: '请输入会议主持人',
            attendingLeadershipEmptyMessage: '请输入出席领导',
            meetingContentEmptyMessage: '请输入会议内容',
            attach: '附件',
            fileName: '文件名',
            fileSize: '文件大小',
            dayone: '周一',
            daytwo: '周二',
            daythree: '周三',
            dayfour: '周四',
            dayfive: '周五',
            daysix: '周六',
            dayseven: '周日',
            day: '{day}号',
            hyglTitle: '补发会议通知',
            selectBfRangeEmptyMessage: '请选择补发范围',
            selectBfRangeElementFormatter: '1：选择人员\n2：选择部门',
            selectPerson: '选择人员',
            selectPersonEmptyMessage: '请选择人员',
            selectDepart: '选择部门',
            scanSignin: '扫描二维码签到',
            meetingAddress: '会议地点：{place}',
            meetingAddress2: '会议地点',
            meetingPerson: '召集人：{person}',
            meetingPhone2: '联系电话:{phone}',
            meetingPhoneEmptyMessage: '请输入纪要人员电话',
            meeingUpdate: '会议变更',
            meetingInfoTitle: '会议管理信息变更',
            meetingTheme: '会议主题',
            meetingThemeEmptyMessage: '请输入会议主题',
            meetingStartTimeEmptyMessage: '请输入会议开始时间',
            meetingEndTimeEmptyMessage: '请输入会议结束时间',
            meetingPersonnelEmptyMessage: '请输入会议纪要人员名称',
            openSginEmptyMessage: '请选择是否开放签到',
            openSginElementFormatter: '1：是\n0：否',
            receiptEndTimemptyMessage: '请输入回执时限',
            openExternalPersonEmptyMessage: '请选择是否有外联人员',
            openExternalPersonElementFormatter: '0：否\n1：是',
            openYtEmptyMessage: '请选择是否添加议题',
            externalPersonNameEmptyMessage: '请输入联络人姓名',
            meetingAgenda: '会议议题',
            meetingDialogTitle: '选择会议目录',
            noAttach: '暂无附件',
            selectYear: '请选择年份',
            topics: '议题',
            reporter: '汇报人',
            reportTime: '汇报时长(分钟)',
            reportTime2: '汇报时长',
            durationTime: '讨论时长(分钟)',
            attendees: '列席人员',
            attachNum: '附件数量',
            meetinger: '会议人员',
            duties: '职务',
            depart: '部门',
            phone: '联系电话',
            personType: '人员类型',
            insider: '内部人员',
            outsiders: '外部人员',
            leader: '领导',
            remarks: '备注',
            meetingMinutes: '会议记录',
            transferRecord: '转派记录',
            transferPersonnel: '转派人',
            transferTime: '转派时间',
            transferReason: '转派原因',
            transferReasonlaceholder: '请输入转派原因',
            seatLayoutSettings: '坐席布局设置',
            longTable: '长型桌子',
            circleTable: '圆型桌子',
            uTable: 'U型桌子',
            auditorium: '大礼堂',
            delEle: '删除元素',
            seatSettingsWindow: '坐席设置窗口',
            meetingRoomType: '会议室类型',
            seats: '坐席',
            longSeats: '长边坐席',
            shortSeats: '短边坐席',
            personUnit: '人',
            personUnit2: '{num}人',
            podiumRowsNum: '主席台排数',
            podiumEveryRowsNum: '主席台每排人数',
            podiumStageOffNum: '主席台下排数',
            podiumStageOffRowsNum: '主席台下每排人数',
            printPersonSeat: '坐席人员标签打印',
            printMeeting: '会议室平面图打印',
            participants: '参会人员',
            participantsPlaceholder: '请输入参会人员',
            labelSize: '标签尺寸',
            long: '长',
            width: '宽',
            inputMeetingType: '请输入会议类型',
            meetingTypeOptinLabel1: '院领导班子会议和院党委会议',
            meetingTypeOptinLabel2: '以院名义举办的会议',
            meetingTypeOptinLabel3: '机关部门召集的会议',
            meetingTypeOptinLabel4: '国际会议',
            meetingTypeOptinVerson1: '院领导班子会议',
            meetingTypeOptinVerson2: '院党委会议',
            meetingTypeOptinVerson3: '院属单位（部门）主要负责同志参加',
            meetingTypeOptinVerson4: '院属单位（部门）负责同志参加',
            meetingTypeOptinVerson5: '院外单位和人员参加',
            meetingTypeOptinVerson6: '院属单位业务部门参加',
            meetingTypeOptinVerson7: '国际会议',
            businessType: '业务类型',
            time: '时间',
            address: '地点',
            timeAddress: '时间：{time} 地点：{address}',
            agendaArrangement: '议题安排：<span style="color: #1a82e3;font-size: 18px;">{num}项</span>议题，时长约 <span style="color: #1a82e3;font-size: 18px;">{time}</span>',
            hostDepartment: '主办部门',
            declarant: '陈述人',
            csStr: '陈述人：{person} 陈述时间{num}分钟',
            csTime: '陈述时间/分钟',
            csTime2: '陈述时间{num}分钟',
            talkTime: '讨论时间/分钟',
            attendDept: '列席部门',
            status: '状态',
            operate: '操作',
            noMeeting: '未上会',
            onMeeting: '已上会',
            waitMeeting: '待上会',
            startReporting: '开始汇报',
            viewReporting: '查看汇报',
            confirmStart: '确认开始',
            ytTitle: '议题材料及附件',
            notTimedOut: '未超时',
            timedOut: '已超时',
            formatTime: '{year}年{month}月{day}日（{weekDay}）{ampm}{formattedHour}:00',
            receipt: '回执',
            substitutePersonnelPlaceholder: '请选择替会人员',
            notAttendingReasonPlaceholder: '请输入不参会原因',
            undertakerPlaceholder: '请选择承办人',
            change: '变更',
            joinMeeting: '会议报名',
            position: '职位',
            positionPlaceholder: '请输入职位',
            orgPlaceholder: '请选择机构员工',
            namePlaceholder: '请输入姓名',
            autoGet: '自动获取',
            departPlaceholder: '请输入部门',
            telphone: '电话',
            telphonePlaceholder: '请输入电话',
            meetingReceipt: '会议回执',
            transfer: '转派',
            transferer: '转派人员',
            transfererPlaceholder: '请选择转派人员',
            meetingDetail: '会议详情',
            meetingInfo: '会议信息',
            noReceived: '未回执',
            participation: '参会',
            noParticipation: '不参会',
            searching: '搜索...',
            sginInfo: '签到信息',
            signIn: '已签到',
            noSignIn: '未签到',
            signTime: '签到时间',
            meetingTj: '会议统计',
            tjScan: '签到统计',
            bmtj: '报名统计',
            fileName2: '文件名称',
            liaisonMan: '联络员',
            noRecord: '暂无记录',
            rulePhone: '电话不能为空',
            ruleGs: '请输入正确格式电话',
            ruleFormat: '请输入11位手机号',
            signCode: '签到二维码',
            personSeatSetting: '人员坐席设置',
            isCancel: '已取消',
            selectTime: '选择日期时间',
            resolution: '决策建议',
            order: '排序',
            everyDay: '每天',
            workDay: '工作日',
            monday: '星期一',
            tuesday: '星期二',
            wednesday: '星期三',
            thursday: '星期四',
            friday: '星期五',
            saturday: '星期六',
            sunday: '星期日',
            sw: '上午',
            xw: '下午',
            toMonth: '本月'
        },
        hyyt: {
            meetingAgenda: '会议议题',
            selectMeeting: '选择议题',
            index: '序号',
            hostDepartment: '主办部门',
            declarant: '陈述人',
            csTime: '陈述时间/分钟',
            csTime2: '陈述时间{num}分钟',
            talkTime: '讨论时间/分钟',
            attendDept: '列席部门',
            status: '状态',
            noMeeting: '未上会',
            onMeeting: '已上会',
            waitMeeting: '待上会',
            attach: '附件',
            order: '排序',
            operate: '操作',
            transferLibrary: '转议题库',
            catalogTopics: '目录议题',
            move: '移动',
            ytkTitle: '议题库',
            selectStartTime: '选择开始时间',
            messageReminder: '消息提醒',
            pleaseSelect: '请选择',
            isReserved: '已预订',
            isCancel: '已取消',
            isApplying: '申请中',
            applyingPass: '申请通过',
            applyingNoPass: '申请不通过',
            meetingStartTime: '会议开始时间',
            meetingEndTime: '会议结束时间',
            conferenceTheme: '会议主题',
            meetingName: '会议室名称',
            appointedBy: '预约人',
            phone: '联系方式',
            numPeople: '会议人数',
            scheduled: '预定状态',
            week: '周',
            day: '日',
            today: '今天',
            toWeek: '本周',
            site: '场地',
            updateScheduled: '修改预约',
            cancelScheduled: '取消预约',
            cancelMeetingType: '取消会议类型',
            cancelCur: '取消当前',
            cancelAfter: '取消后续',
            cancellation: '取消预订',
            lation: '已预订',
            meetingLation: '会议室预定',
            toApply: '去申请',
            finishLation: '完成预定',
            meetingMap: '会议室导览图',
            Configuration: '设备配置：',
            alreadyBooked: '已约满',
            notAppointment: '不可预约',
            appointment: '预 约',
            startTime: '开始时间',
            endTime: '结束时间',
            meetingDialogTitle: '选择会议目录'
        },
        portlet: {
            personUnit: '{num}人',
            conferenceTheme: '会议主题：',
            conference: '请输入会议主题',
            participants: '参会人员：',
            chryTip: '参会人员是必须的！',
            totalTime: '共{allTime}小时',
            participantsPlaceholder: '请输入参会人员',
            enterReservation: '进入预定',
            isQuickMeeting: '是否快速预定该会议室？',
            quickBooking: '快速预定',
            toolTip: '不可预订已过时间的会议室',
            toolTip2: '过去时段被预订',
            toolTip3: '当前时段已被预订',
            isNullMeeting: '暂时没有空闲会议室哦~',
            isRowsNullMeeting: '您选择的楼层暂时没有空闲会议室哦~',
            selectOtherFloor: '请选择其他楼层进行检索',
            meetingTime: '会议时段',
            bookNow: '立刻预定',
            hasBook: '会议室已被预订',
            gwap: '公务安排',
            index: '序号',
            conferenceTitle: '会议主题：',
            meetingRoom: '会议室',
            startTime: '开始时间',
            endTime: '结束时间',
            convener: '召集人：'
        },
        voteManage: {
            resolutionVoting: '决议投票',
            look: '查看',
            statistics: '统计',
            topUp: '置顶',
            grounding: '上架',
            offShelf: '下架',
            addTopic: '添加题目',
            submitwj: '提交问卷',
            notSelevtTopit: '还有题目未选择！',
            voteed: '您已完成投票',
            votingResults: '投票结果',
            votinger: '投票人',
            promoter: '发起人：{voteName}',
            deadline: '截止时间：{endTime}',
            voto: '{num}票',
            votoTitle: '投票主题:{voteTheme}',
            votoScan: '手机扫描二维码投票',
            votoScan2: '投票二维码',
            total: '合计',
            voting: '投票',
            Radio: '单选',
            multipleChoice: '多选',
            item: '选项{num}',
            specifyGroup: '指定群组',
            specifyGroupPlaceholder: '请选择指定群组',
            specifyDepart: '指定部门',
            specifyDepartPlaceholder: '请选择指定部门',
            specifyPerson: '指定人员',
            specifyPersonPlaceholder: '请选择指定人员',
            isVoto: '已投票',
            noVoto: '未投票',
            votoTotal: '投票统计',
            join: '参与',
            abstained: '弃票',
            votoDetail: '投票明细',
            questionnaireCode: '问卷二维码',
            topic: '题目',
            votoTopic: '投票题目',
            votoTopicPlaceholder: '投票题目',
            votoType: '投票类型',
            votoTypePlaceholder: '投票类型',
            votingOptions: '投票选项',
            optionTitle: '选项标题',
            pic: '图片',
            picPlaceholder: '请选择图片',
            addItem: '添加选项'
        },
        menuItem: {
            meetingHome: '会议主页',
            meetingSchedule: '会议日程',
            myMeeting: '我的会议',
            pendingReceipt: '待回执',
            waitingAttend: '待参会',
            alreadyAttended: '已参会',
            noParticipation: '不参会',
            alreadyCancel: '已取消',
            meeetingConference: '会议报名',
            meetingReservation: '会议室预定',
            initiateReservation: '发起预定',
            scheduledRecords: '预定记录',
            bookingApplication: '预定申请',
            meetingNotice: '会议通知',
            meetingAgenda: '会议议题',
            myAgenda: '我的议题',
            meetingMinutes: '会议纪要',
            meetingVoting: '会议投票',
            topicCollection: '议题收集',
            topicReporting: '议题上报',
            ytkTitle: '议题库',
            notGenerated: '未生成',
            generated: '已生成',
            conferenceDirectory: '会议目录',
            tobeHeld: '待召开',
            inProgress: '召开中',
            convened: '已召开',
            resolutionVoting: '决议投票',
            notStarted: '未开始',
            oning: '进行中',
            meetingManagement: '上会管理',
            todayMeeting: '今天会议',
            waitingMeeting: '待参会议',
            historicalConference: '历史会议',
            issueLog: '议题纪要',
            resourceManagement: '资源管理',
            conferenceRoomManagement: '会议室管理',
            meetingType: '会议类型',
            siteManagement: '场地管理',
            equipmentManagement: '设备管理',
            huifuManagement: '会服管理',
            myStated: '我陈述的',
            isVoto: '已投票',
            noVoto: '未投票',
            //通用
            all: '全部',
            myCreate: '我组织的',
            mycreated: '我创建的',
            todo: '待处理',
            done: '已处理',
            processingProgress: '处理中',
            myDraft: '我起草的',
            draft: '草稿',
            Ended: '已结束',
            myHandled: '我处理的',
            allApplications: '全部申请',
            noSelect: '未选择',
            isSelect: '已选择'
        },
        voteResult: {
            formTitle: '',
            fields: {
                index: '序号',
                depart: '部门',
                votinger: '投票人',
                phone: '联系方式',
                votingResults: '投票结果'
            }
        },
        jyap: {
            //会议纪要申请
            formTitle: '会议纪要申请',
            fields: {
                meetingName: '会议主题',
                startTime: '会议开始时间 ',
                flCreator: '创建人',
                endTime: '会议结束时间 ',
                flCreateDept: '创建部门',
                flCreatorPhone: '联系电话',
                flContent: '会议决议',
                meetPlace: '会议地点',
                flSubject: '会议纪要标题',
                flCreateDate: '创建日期 ',
                attendName: '参会人员'
            }
        },
        meetingRoom: {
            //会议室管理
            formTitle: '会议室管理',
            fields: {
                meetImgurl: '会议室图片',
                approve: '是否需要审批',
                meetName: '会议室名称',
                site: '会议室场地',
                deviceProperties: '设备配置 ',
                servePersonName: '会议室服务人员',
                remark: '备注',
                layoutName: '座位设置',
                serviceProperties: '服务配置 ',
                userIdName: '会议室管理员',
                meetId: '会议室编号',
                status: '状态 ',
                openTime: '开放时间',
                openDate: '开放周期'
            },
            options: {
                approve: {
                    1: '是',
                    0: '否'
                },
                status: {
                    1: '启用',
                    0: '禁用'
                }
            }
        },
        ytsj: {
            //议题收集
            formTitle: '议题收集',
            close: '关 闭',
            issued: '下 发',
            fields: {
                deptName: '收集相关部门',
                content: '议题收集任务',
                remark: '备注',
                reportEndDate: '征集结束时间'
            },
            options: {
                sendType: {
                    1: '定时下发',
                    2: '立即下发'
                }
            }
        },
        ytsjInfo: {
            topicReport: '议题上报',
            fields: {
                endTime: '征集结束时间'
            }
        },
        hyap: {
            //会议通知
            formTitle: '会议通知',
            meetChangeTitle: '会议管理信息变更',
            selectHyml: '选择会议目录',
            meetRecord: '会议笔记',
            meetSeat: '会议排座',
            pre: '上一个',
            next: '下一个',
            fields: {
                openYt: '是否添加议题 ',
                summaryPhone: '联系电话',
                flCreatorPhone: '联系电话',
                meetPlace: '会议地点',
                workMum: '参会人数',
                meetHost: '会议主持人',
                startTime: '会议开始时间 ',
                openExternalPerson: '是否有外联人员 ',
                mainDept: '主办部门',
                receiptEndTime: '回执时限',
                flSubject: '会议议题',
                attendName: '列席人员',
                flContent: '会议内容',
                meetingTypeName: '会议类型',
                meetShape: '会议形式 ',
                endTime: '会议结束时间 ',
                openSgin: '是否开放签到 ',
                flCreator: '申请人',
                externalPersonName: '联络人',
                summaryName: '会议纪要人员',
                flCreateDate: '申请日期 ',
                flCreateDept: '申请部门',
                sAttendName: '随议题列席人员',
                attendLeader: '参会领导'
            },
            options: {
                meetShape: {
                    1: '个人参会',
                    2: '部门参会'
                },
                openSgin: {
                    1: '是',
                    0: '否'
                },
                openExternalPerson: {
                    1: '是',
                    0: '否'
                },
                openYt: {
                    1: '是',
                    0: '否'
                }
            }
        },
        hyapYtInfo: {
            //会议通知议题明细
            formTitle: '会议通知议题明细',
            dialogTitle: '目录议题',
            meetSubject: '会议主题',
            selectSubject: '请选择会议议题。',
            fields: {
                mainDept: '主办部门',
                createDate: '创建时间',
                reportTime: '汇报时间/分钟',
                creator: '登记人',
                isAttendDept: '固定列席部门',
                subject: '会议议题',
                talkTime: '讨论时间/分钟',
                isPpt: '是否PPT演示',
                isWritten: '书面通报',
                attendDept: '列席部门',
                remark: '备注',
                reportPersonName: '陈述人',
                subjectTypeName: '会议类型',
                attendStoolName: '列席人员'
            }
        },
        vwMyMeeting: {
            meetDetail: '会议详情',
            fields: {
                meetTime: '会议时间',
                mainDept: '主办部门',
                meetingTypeName: '会议类型名称',
                meetPlace: '会议室地点',
                meetHost: '会议主持人',
                attendName: '全部参会人员',
                attendLeader: '参会人员',
                attendperson: '列席人员',
                summaryName: '纪要人员',
                summaryPhone: '联系电话',
                flContent: '会议内容'
            },
            meetInfo: {
                title: '会议信息',
                meetTheme: '会议主题',

                startTime: '开始时间',
                endTime: '结束时间',
                meetType: '会议类型',
                meetPlace: '会议室地点',
                meetHost: '会议主持人',
                attendLeader: '参会人员',
                attendperson: '列席人员',
                sAttendName: '随议题出席人员',
                summaryName: '纪要人员',
                summaryPhone: '联系电话',
                meetContent: '会议内容',
                meetAttach: '会议附件'
            },
            meetingAgenda: {
                title: '会议议题',
                mainDept: '主办部门',
                reportPersonName: '陈述人',
                reportTime: '陈述时长(分钟)',
                talkTime: '讨论时长(分钟)',
                attendperson: '列席人员',
                fileCount: '附件数量'
            },
            attendees: {
                title: '列席人员',
                personType: '人员类型',
                insiderPersonnel: '内部人员',
                outsiderPersonnel: '外部人员',
                username: '姓名',
                userPost: '职务',
                dept: '部门',
                phone: '联系电话',
                remark: '备注'
            },
            meetingRecords: {
                title: '会议记录',
                write: '请填写'
            }
        },
        meetingEpment: {
            //设备管理
            formTitle: '设备管理',
            fields: {
                epmentNo: '排序编号',
                epmentName: '会议室设备'
            }
        },
        meeting: {
            //会议室预定表（副本）
            formTitle: '会议室预定表',
            fields: {
                agentPhone: '经办人电话',
                agentUser: '经办人',
                meetSubjedt: '会议主题',
                meetName: '会议室',
                serviceProperties: '服务配置 ',
                deviceProperties: '设备配置',
                week: '预定周期 ',
                weeks: '开放周期',
                applayName: '预约人',
                attendUserName: '参会人员',
                numPeople: '参加人数',
                preordainType: '预定类型 ',
                meetDetails: '会议内容',
                meetTime: '会议时间',
                departmentUser: '使用部门',
                endTime: '结束时间 ',
                beginTime: '开始时间 ',
                meetInfo: '会议室信息',
                remind: '提醒方式'
            },
            options: {
                preordainType: {
                    0: '一次性',
                    1: '周期性'
                }
            }
        },
        vote: {
            //决议投票》投票主题
            formTitle: '决议投票》投票主题',
            fields: {
                startTime: '开始时间',
                voteTheme: '投票主题',
                sponsor: '发起人',
                endTime: '截止时间',
                voteType: '投票方式',
                voteRange: '投票范围'
            },
            options: {
                voteType: {
                    1: '记名投票',
                    2: '不记名投票'
                },
                voteRange: {
                    1: '全部',
                    2: '部门',
                    4: '指定人'
                }
            }
        },
        meetDirectory: {
            //会议目录
            // formTitle: '会议目录',
            // fields: {
            //     createDate: '创建日期 ',
            //     subjectTypeName: '会议类型名称',
            //     creator: '创建人',
            //     subject: '会议目录'
            // }
        },
        meetingServe: {
            //会议室服务
            formTitle: '会议室服务',
            fields: {
                imageName: '服务照片',
                epmentNo: '排序编号',
                epmentName: '服务名称'
            }
        },
        ytRecord: {
            //议题库
            formTitle: '议题库',
            fields: {
                resolution: '建议审议的决议'
            },
            isPpt: {
                1: '是',
                0: '否'
            },
            isAttendDept: {
                1: '是',
                0: '否'
            },
            isWritten: {
                1: '是',
                0: '否'
            }
        },
        plan: {
            //会议计划
            formTitle: '会议计划',
            fields: {
                flCreateDate: '创建日期',
                attendNum: '参加人员数',
                meetPlace: '会议地点',
                endTime: '会议结束时间',
                flCreateDept: '部门',
                meetContent: '会议内容',
                flCreator: '创建人',
                stsrtTime: '会议开始时间',
                meetTheme: '会议主题'
            }
        },
        cysy: {
            //会议管理》传阅审议
            formTitle: '会议管理》传阅审议',
            fields: {
                flDealDate: '办理期限',
                flCreatorPhone: '联系电话',
                flCreator: '申请人',
                flCreateDate: '申请日期 ',
                meetingTypeName: '会议类型',
                ytName: '会议议题',
                resolution: '建议审议的决议',
                flJbr: '经办人',
                flSubject: '会议主题',
                mainDept: '主办部门',
                flCreateDept: '申请部门'
            }
        },
        deptytRecord: {
            //部门议题库
            formTitle: '部门议题库',
            fields: {
                isAttendDept: '固定列席部门',
                talkTime: '讨论时间/分钟',
                attendDept: '列席部门',
                isPpt: '是否PPT演示',
                mainDept: '主办部门',
                remark: '备注',
                attendStoolName: '列席人员',
                createDate: '申请日期 ',
                reportPersonName: '陈述人',
                creator: '申请人',
                isWritten: '书面通报',
                subject: '会议议题',
                reportTime: '汇报时间/分钟',
                resolution: '建议审议的决议',
                subjectTypeName: '会议类型'
            }
        },
        roomApply: {
            //会议室申请表（副本）
            formTitle: '会议室申请表',
            fields: {
                flContent: '会议内容',
                remark: '备注',
                flSubject: '会议主题',
                agentUser: '经办人',
                agentPhone: '经办人电话',
                preordainType: '预定类型 ',
                flCreateDept: '申请部门',
                meetName: '会议室名称',
                flCreatorPhone: '联系电话',
                flCreateDate: '申请日期',
                flCreator: '申请人',
                meetPlace: '会议室地点',
                hysSelect: '会议预定选择:',
                meetTime: '会议时间',
                weekday: '会议日期',
                endTime: '会议时间点',
                yyDataRange: '应用日期范围',
                checkListss1: '预定周期',
                remind: '提醒方式',
                meetInfo: '会议室信息',
                numPeople: '会议室容量',
                fwpz: '服务配置',
                hyssb: '会议室设备',
                weekProperties: '开放周期'
            },
            options: {
                preordainType: {
                    0: '一次性',
                    1: '周期性'
                }
            }
        },
        site: {
            //场地管理
            formTitle: '场地管理',
            fields: {
                orderNo: '排序编号',
                name: '场地名称',
                status: '状态 '
            },
            options: {
                status: {
                    0: '禁用',
                    1: '启用'
                }
            }
        },
        ytap: {
            //会议议题
            formTitle: '会议议题',
            fields: {
                attendStoolName: '列席人员',
                reportTime: '汇报时长（分钟）',
                isAttendDept: '固定列席部门',
                flCreatorPhone: '联系电话',
                resolution: '建议审议的决议',
                isPpt: '是否ppt演示',
                ytsjName: '关联议题收集任务',
                remark: '备注',
                mainDept: '主办部门',
                flCreateDept: '申请部门',
                talkTime: '讨论时长（分钟）',
                isWritten: '书面通报',
                endTime: '征集结束时间',
                reportPersonName: '陈述人',
                flSubjectType: '会议类型',
                flCreateDate: '申请日期 ',
                flSubject: '会议议题',
                attendDept: '列席部门',
                flCreator: '申请人'
            },
            options: {
                isPpt: {
                    1: '是',
                    0: '否'
                },
                isAttendDept: {
                    1: '是',
                    0: '否'
                },
                isWritten: {
                    1: '是',
                    0: '否'
                }
            }
        },
        overTime: {
            formTitle: '超时未提交议题'
        },
        type: {
            //会议类型
            formTitle: '会议类型',
            fields: {
                orderNo: '排序',
                typeName: '会议类型',
                status: '状态 '
            },
            options: {
                status: {
                    1: '启用',
                    0: '禁用'
                }
            }
        },
        meetPeople: {
            //参与会议人员表
            formTitle: '参与会议人员表',
            fields: {
                remark: '备注',
                userName: '姓名',
                userPost: '职务',
                userDept: '部门',
                personType: '人员类型 ',
                phone: '电话',
                remark2: '拒绝原因',
                signTime: '附件数'
            }
        },
        ytjy: {
            //议题纪要
            formTitle: '议题纪要',
            fields: {
                flCreator: '申请人',
                flCreateDept: '申请部门',
                flContent: '议题纪要内容',
                startTime: '会议开始时间',
                endTime: '会议结束时间',
                flSubject: '会议主题',
                flCreateDate: '申请日期 ',
                flCreatorPhone: '联系电话',
                hyapYt: '议题纪要标题'
            },
            addShyt: '添加上会议题',
            isWrittenTip: '提示：请自行打印纸质材料带至会议现场'
        }
    }
}
